import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Checkbox, CheckboxGruppe } from "./../../";
import Alertstripe from "./../../../nav-frontend-alertstriper";
import Lenke from "./../../../nav-frontend-lenker";
export const _frontmatter = {
  "ingress": "Checkbox er en komponent som benyttes i skjemaer for å gi brukeren muligheten til å avgi et eller flere svar på spørsmålet som blir stilt."
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Example = makeShortcode("Example");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <nav {...{
      "className": "table-of-contents"
    }}><ol parentName="nav" {...{
        "className": "toc-level toc-level-1"
      }}><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#normal"
          }}>{`Normal`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#disabled"
          }}>{`Disabled`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#feilmelding"
          }}>{`Feilmelding`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#checkboxgruppe"
          }}>{`CheckboxGruppe`}</a><ol parentName="li" {...{
            "className": "toc-level toc-level-2"
          }}><li parentName="ol" {...{
              "className": "toc-item toc-item-h3"
            }}><a parentName="li" {...{
                "className": "toc-link toc-link-h3",
                "href": "#felles-feilmelding"
              }}>{`Felles feilmelding`}</a></li><li parentName="ol" {...{
              "className": "toc-item toc-item-h3"
            }}><a parentName="li" {...{
                "className": "toc-link toc-link-h3",
                "href": "#feilmelding-uten-propagering-av-feil-prop-til-children"
              }}>{`Feilmelding uten propagering av feil-prop til children`}</a></li></ol></li></ol></nav>
    <h2 {...{
      "id": "normal"
    }}>{`Normal`}</h2>
    <Example mdxType="Example">
  <Checkbox label={"Checkbox"} mdxType="Checkbox" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Checkbox label={"Checkbox"} />
`}</code></pre>
    <h2 {...{
      "id": "disabled"
    }}>{`Disabled`}</h2>
    <Alertstripe type="advarsel" mdxType="Alertstripe">
  Merk at disabled bør unngås, og at bruken heller bør løses på andre måter, da
  fks kombinert med tydelige feilmeldinger hvis handlingen av en eller annen
  grunn ikke er tillatt. Ler mer om dette på{" "}
  <Lenke href="/accessibility/disabled" mdxType="Lenke">siden vår om `disabled`</Lenke>.
    </Alertstripe>
    <Example mdxType="Example">
  <Checkbox label={"Checkbox"} disabled mdxType="Checkbox" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Checkbox label={"Checkbox"} disabled />
`}</code></pre>
    <h2 {...{
      "id": "feilmelding"
    }}>{`Feilmelding`}</h2>
    <Example mdxType="Example">
  <Checkbox label={"Checkbox"} feil="Feilmeldingstekst må gjenta nøkkelord fra label" mdxType="Checkbox" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Checkbox
  label={"Checkbox"}
  feil="Feilmeldingstekst må gjenta nøkkelord fra label"
/>
`}</code></pre>
    <h2 {...{
      "id": "checkboxgruppe"
    }}>{`CheckboxGruppe`}</h2>
    <p>{`Denne komponenten inkluderer også en `}<inlineCode parentName="p">{`CheckboxGruppe`}</inlineCode>{`-komponent som kan brukes til å gruppere flere checkboxer:`}</p>
    <Example mdxType="Example">
  <CheckboxGruppe legend="Hvor vil du sitte?" mdxType="CheckboxGruppe">
    <Checkbox label={"Bakerst"} mdxType="Checkbox" />
    <Checkbox label={"Midten"} mdxType="Checkbox" />
    <Checkbox label={"Fremst"} mdxType="Checkbox" />
  </CheckboxGruppe>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { CheckboxGruppe, Checkbox } from "nav-frontend-skjema";

<CheckboxGruppe legend="Hvor vil du sitte?">
  <Checkbox label={"Bakerst"} />
  <Checkbox label={"Midten"} />
  <Checkbox label={"Fremst"} />
</CheckboxGruppe>;
`}</code></pre>
    <h3 {...{
      "id": "felles-feilmelding"
    }}>{`Felles feilmelding`}</h3>
    <Example mdxType="Example">
  <CheckboxGruppe legend="Hvor vil du sitte?" feil="Feilmeldingstekst må gjenta nøkkelord fra label" mdxType="CheckboxGruppe">
    <Checkbox label={"Bakerst"} mdxType="Checkbox" />
    <Checkbox label={"Midten"} mdxType="Checkbox" />
    <Checkbox label={"Fremst"} mdxType="Checkbox" />
  </CheckboxGruppe>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { CheckboxGruppe, Checkbox } from "nav-frontend-skjema";

<CheckboxGruppe
  legend="Hvor vil du sitte?"
  feil="Feilmeldingstekst må gjenta nøkkelord fra label"
>
  <Checkbox label={"Bakerst"} />
  <Checkbox label={"Midten"} />
  <Checkbox label={"Fremst"} />
</CheckboxGruppe>;
`}</code></pre>
    <h3 {...{
      "id": "feilmelding-uten-propagering-av-feil-prop-til-children"
    }}>{`Feilmelding uten propagering av feil-prop til children`}</h3>
    <p>{`Bruk `}<inlineCode parentName="p">{`utenFeilPropagering`}</inlineCode>{`-propen for å bestemme om `}<inlineCode parentName="p">{`feil`}</inlineCode>{`-propen til `}<inlineCode parentName="p">{`CheckboxGruppe`}</inlineCode>{` skal propageres til children.`}</p>
    <Example mdxType="Example">
  <CheckboxGruppe legend="Hvor vil du sitte?" feil="Feilmeldingstekst må gjenta nøkkelord fra label" utenFeilPropagering mdxType="CheckboxGruppe">
    <Checkbox label={"Bakerst"} mdxType="Checkbox" />
    <Checkbox label={"Midten"} feil mdxType="Checkbox" />
    <Checkbox label={"Fremst"} mdxType="Checkbox" />
  </CheckboxGruppe>
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { CheckboxGruppe, Checkbox } from "nav-frontend-skjema";

<CheckboxGruppe
  legend="Hvor vil du sitte?"
  feil="Feilmeldingstekst må gjenta nøkkelord fra label"
  utenFeilPropagering
>
  <Checkbox label={"Bakerst"} />
  <Checkbox label={"Midten"} feil />
  <Checkbox label={"Fremst"} />
</CheckboxGruppe>;
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      